/**
 * Rota `/admin/regra-de-papel` (E1b Fase C, Task 13).
 *
 * Como `/admin/mapa-de-acesso`, `/admin/perfis` e `/admin/home-widgets`, é tela
 * admin meta e NÃO é registrada em `system_modules` — registrar poluiria o
 * catálogo e exigiria health check sem ganho.
 *
 * O gate é `mapa_acesso:manage`, o MESMO do Mapa de Acesso, e é o mesmo do
 * backend (`admin_papel_regra.py`): quem pode dizer que um setor recebe um
 * papel pode dizer que um critério recebe um papel. Uma permissão nova aqui
 * criaria uma terceira porta para a mesma decisão.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const PapelRegraPage = lazy(() => import("@/pages/admin/PapelRegraPage"));

export const adminPapelRegraRoutes: ModuleRoutes = {
  moduleId: "admin_papel_regra",
  basePath: "/admin/regra-de-papel",
  routes: [
    {
      path: "/admin/regra-de-papel",
      element: <PapelRegraPage />,
      permission: { resource: "mapa_acesso", action: "manage" },
    },
  ],
};
